import { render } from "./HomeView.vue?vue&type=template&id=246a9a46&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=246a9a46&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246a9a46"]])

export default __exports__